import AudienceTableHeaderContainer from './audienceTableHeader';

export default AudienceTableHeaderContainer;
